module.exports = __webpack_public_path__ + "img/premium_bodyimage01.920e5314.jpg";